module.exports = __webpack_public_path__ + "demo_anc_q7_2.jpg?176a57eea977092e430a6845df3c2b39";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo_anc_q7_2.jpg
// module id = 561
// module chunks = 0